import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CryptoNewsBar } from './components/CryptoNewsBar';
import { CompareBar } from './components/CompareBar';
import { CompareProvider, useCompare } from './contexts/CompareContext';
import { HomePage } from './pages/HomePage';
import { CryptocurrenciesPage } from './pages/CryptocurrenciesPage';
import { ExchangesPage } from './pages/ExchangesPage';
import { CryptoDetailPage } from './pages/CryptoDetailPage';
import { ExchangeDetailPage } from './pages/ExchangeDetailPage';
import { SocialMediaPage } from './pages/SocialMediaPage';
import { RSSIntegrationPage } from './pages/RSSIntegrationPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { CompareExchangesPage } from './pages/CompareExchangesPage';
function AppContent() {
  const {
    compareList,
    removeFromCompare,
    clearCompare
  } = useCompare();
  return <div className="flex flex-col min-h-screen pb-48" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/cryptocurrencies" element={<CryptocurrenciesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/exchanges" element={<ExchangesPage data-id="element-9" />} data-id="element-8" />
          <Route path="/cryptocurrency/:id" element={<CryptoDetailPage data-id="element-11" />} data-id="element-10" />
          <Route path="/exchange/:id" element={<ExchangeDetailPage data-id="element-13" />} data-id="element-12" />
          <Route path="/social-media" element={<SocialMediaPage data-id="element-15" />} data-id="element-14" />
          <Route path="/opportunities" element={<RSSIntegrationPage data-id="element-17" />} data-id="element-16" />
          <Route path="/terms-of-use" element={<TermsOfUsePage data-id="element-19" />} data-id="element-18" />
          <Route path="/compare" element={<CompareExchangesPage data-id="element-21" />} data-id="element-20" />
        </Routes>
      </main>
      <Footer data-id="element-22" />
      <CryptoNewsBar data-id="element-23" />
      <CompareBar exchanges={compareList} onRemove={removeFromCompare} onClear={clearCompare} data-id="element-24" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-25">
      <CompareProvider data-id="element-26">
        <AppContent data-id="element-27" />
      </CompareProvider>
    </BrowserRouter>;
}